module.exports = __webpack_public_path__ + "img/mmi-about-photo-team-carl.79c032d7.png";